<template>
  <div class="icon-container">
    <svg :style="`width: ${width}; height: ${height}; fill: ${fill}`">
      <use :xlink:href="iconName" />
    </svg>
    <svg display="none">
      <!-- MAIN MENU -->
      <symbol :width="width" :height="height" viewBox="0 0 45.532 45.532" id="user" v-if="name == 'user'">
          <path d="M22.766,0.001C10.194,0.001,0,10.193,0,22.766s10.193,22.765,22.766,22.765c12.574,0,22.766-10.192,22.766-22.765
            S35.34,0.001,22.766,0.001z M22.766,6.808c4.16,0,7.531,3.372,7.531,7.53c0,4.159-3.371,7.53-7.531,7.53
            c-4.158,0-7.529-3.371-7.529-7.53C15.237,10.18,18.608,6.808,22.766,6.808z M22.761,39.579c-4.149,0-7.949-1.511-10.88-4.012
            c-0.714-0.609-1.126-1.502-1.126-2.439c0-4.217,3.413-7.592,7.631-7.592h8.762c4.219,0,7.619,3.375,7.619,7.592
            c0,0.938-0.41,1.829-1.125,2.438C30.712,38.068,26.911,39.579,22.761,39.579z"/>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 45.532 45.532" id="userinfo" v-if="name == 'usericon'">
          <path d="M22.766,0.001C10.194,0.001,0,10.193,0,22.766s10.193,22.765,22.766,22.765c12.574,0,22.766-10.192,22.766-22.765
            S35.34,0.001,22.766,0.001z M22.766,6.808c4.16,0,7.531,3.372,7.531,7.53c0,4.159-3.371,7.53-7.531,7.53
            c-4.158,0-7.529-3.371-7.529-7.53C15.237,10.18,18.608,6.808,22.766,6.808z M22.761,39.579c-4.149,0-7.949-1.511-10.88-4.012
            c-0.714-0.609-1.126-1.502-1.126-2.439c0-4.217,3.413-7.592,7.631-7.592h8.762c4.219,0,7.619,3.375,7.619,7.592
            c0,0.938-0.41,1.829-1.125,2.438C30.712,38.068,26.911,39.579,22.761,39.579z"/>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 48 48" id="arr-up" v-if="name == 'arr-up'">
          <path d="M14.83 30.83L24 21.66l9.17 9.17L36 28 24 16 12 28z"></path>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 48 48" id="arr-down" v-if="name == 'arr-down'">
          <path d="M14.83 16.42L24 25.59l9.17-9.17L36 19.25l-12 12-12-12z"></path>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 48 48" id="arr-left" v-if="name == 'arr-left'">
          <path d="M30.83 32.67l-9.17-9.17 9.17-9.17L28 11.5l-12 12 12 12z"></path>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 48 48" id="arr-right" v-if="name == 'arr-right'">
          <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 48 48" id="page-right" v-if="name == 'page-right'">
          <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 32 32" id="cart" v-if="name == 'cart'">
          <g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#111111" stroke="#111111">
            <circle fill="none" stroke-miterlimit="10" cx="10" cy="28" r="3"></circle>
            <circle fill="none" stroke-miterlimit="10" cx="27" cy="28" r="3"></circle>
            <polyline fill="none" stroke="#111111" stroke-miterlimit="10" points="5.8,6 30,6 28,21 8,21 5,1 1,1 " stroke-linecap="butt">
            </polyline>
          </g>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 432 432" id="abc" v-if="name == 'abc'">
          <g>
            <polygon points="234.24,9.067 183.893,59.413 284.587,59.413 			"/>
            <polygon points="301.44,304.32 427.947,120.853 427.947,93.973 250.88,93.973 250.88,128.107 376.32,128.107 250.027,310.72 
              250.027,338.24 432,338.24 432,304.32 			"/>
            <polygon points="234.24,422.933 283.947,373.227 184.533,373.227 			"/>
            <path d="M226.773,338.24L130.987,93.76H96L0,338.24h39.253l19.627-52.267h109.013l19.627,52.267H226.773z M71.893,250.987
              L113.28,140.48l41.387,110.507H71.893z"/>
          </g>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 -53 384 384" id="menu" v-if="name == 'menu'">
        <path xmlns="http://www.w3.org/2000/svg" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
        <path xmlns="http://www.w3.org/2000/svg" d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
        <path xmlns="http://www.w3.org/2000/svg" d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"/>
      </symbol>
      <symbol :width="width" :height="height" viewBox="0 0 41.756 41.756" id="close" v-if="name == 'close'">
        <path d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
        c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
        C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
        c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"/>
      </symbol>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
    //   width: "110px",
    //   height: "110px",
    };
  },

  computed: {
    iconName() {
      return `#${this.name}`;
    },
  },
  props: {
    name: String,
    width: String,
    height: String,
    fill: String
  },

  methods: {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Reusables/Icon.vue